import Clipboard from '@react-native-clipboard/clipboard';
import { Buffer } from 'buffer';
import dayjs from 'dayjs';
import { Platform } from 'react-native';

export * from './device';
export * from './hooks';
export * from './random';

export const copyToClipboard = (text: string) => {
  if (Platform.OS === 'web') {
    navigator.clipboard.writeText(text);
  } else {
    Clipboard.setString(text);
  }
};

export const formatPrice = (value: number | undefined, options?: { removeSign?: boolean } = {}) => {
  const result = value !== undefined ? `$${value.toFixed(2)}`.replace('$-', '-$') : '-';

  if (options.removeSign) {
    return result.replace('-', '');
  }

  return result;
};

export const formatDate = (dateString: string | Date, format: 'short' | 'long' = 'long') => {
  const map = {
    short: 'D MMM, YYYY',
    long: 'D MMM, YYYY HH:mm',
  };

  return dayjs(dateString).format(map[format]);
};

export const decodeToken = (token: string) =>
  JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString('ascii'));

export const lightenDarkenColor = (col: string, amt: number) => {
  var usePound = false;

  if (col[0] == '#') {
    col = col.slice(1);
    usePound = true;
  }

  var num = parseInt(col, 16);

  var r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  var b = ((num >> 8) & 0x00ff) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  var g = (num & 0x0000ff) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
};

export const cx = (...args: (string | boolean | undefined)[]) => {
  return args.filter(Boolean).join(' ');
};
